import { useState, useEffect } from 'react';
import debounce from 'lodash-es/debounce';

export function useResize(delay = 250) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  const handleReSize = debounce(() => {
    setWindowWidth(window.innerWidth);
    setWindowHeight(window.innerHeight);
  }, delay);

  useEffect(() => {
    window.addEventListener('resize', handleReSize);
    return () => {
      window.removeEventListener('resize', handleReSize);
    };
  }, [handleReSize]);

  return { windowWidth, windowHeight };
}
